package com.xtream.ui.ui.component.extension

import androidx.compose.ui.Modifier

fun Modifier.ifElse(
    condition: () -> Boolean,
    ifTrueModifier: Modifier,
    ifFalseModifier: Modifier = this,
): Modifier = then(if (condition()) ifTrueModifier else ifFalseModifier)

fun Modifier.ifElse(
    condition: Boolean,
    ifTrueModifier: Modifier,
    ifFalseModifier: Modifier = this,
): Modifier = ifElse({ condition }, ifTrueModifier, ifFalseModifier)

